import * as R from 'ramda';

import appraisalTheme, {
  muiTheme as appraisalMuiTheme,
} from './themes/appraisal-theme';
import assessmentTheme, {
  muiTheme as assessmentMuiTheme,
} from './themes/assessment-theme';
import baseTheme, { muiTheme } from './themes/base-theme';
import biTheme, { muiTheme as biMuiTheme } from './themes/bi-theme';
import ciTheme, { muiTheme as ciMuiTheme } from './themes/ci-theme';
import dataCaptureTheme, {
  muiTheme as dataCaptureMuiTheme,
} from './themes/dataCapture-theme';
import auditsTheme, { muiTheme as auditsMuiTheme } from './themes/audits-theme';
import eventsTheme, { muiTheme as eventsMuiTheme } from './themes/events-theme';
import litigationTheme, {
  muiTheme as litigationMuiTheme,
} from './themes/litigation-theme';
import mraTheme, { muiTheme as mraMuiTheme } from './themes/mra-theme';
import sketchTheme, { muiTheme as sketchMuiTheme } from './themes/sketch-theme';
import appraisalAdminTheme, {
  muiTheme as appraisalAdminMuiTheme,
} from './themes/appraisal-admin-theme';
import analysisTheme, {
  muiTheme as analysisMuiTheme,
} from './themes/analysis-theme';
import appealsTheme, {
  muiTheme as appealsMuiTheme,
} from './themes/appeals-theme';
import appraisalProcessManagerTheme, {
  muiTheme as appraisalProcessManagerMuiTheme,
} from './themes/appraisal-process-manager-theme';
import queueTheme, { muiTheme as queueMuiTheme } from './themes/queue-theme';
import mobileTheme, { muiTheme as mobileMuiTheme } from './themes/mobile-theme';
import prodigyVirtualHelpTheme, {
  muiTheme as prodigyVirtualHelpMuiTheme,
} from './themes/prodigy-virtual-help';
import conferencingTheme, {
  muiTheme as conferencingMuiTheme,
} from './themes/conferencing-theme';
import bradsqlTheme, {
  muiTheme as bradsqlMuiTheme,
} from './themes/bradsql-theme';

const themeMap = {
  analysis: { theme: analysisTheme, muiTheme: analysisMuiTheme },
  appeals: { theme: appealsTheme, muiTheme: appealsMuiTheme },
  appraisal: { theme: appraisalTheme, muiTheme: appraisalMuiTheme },
  appraisalAdmin: {
    theme: appraisalAdminTheme,
    muiTheme: appraisalAdminMuiTheme,
  },
  appraisalProcessManager: {
    theme: appraisalProcessManagerTheme,
    muiTheme: appraisalProcessManagerMuiTheme,
  },
  assessment: { theme: assessmentTheme, muiTheme: assessmentMuiTheme },
  audits: { theme: auditsTheme, muiTheme: auditsMuiTheme },
  base: { theme: baseTheme, muiTheme },
  bi: { theme: biTheme, muiTheme: biMuiTheme },
  bradsql: { theme: bradsqlTheme, muiTheme: bradsqlMuiTheme },
  ci: { theme: ciTheme, muiTheme: ciMuiTheme },
  conferencing: { theme: conferencingTheme, muiTheme: conferencingMuiTheme },
  dataCapture: { theme: dataCaptureTheme, muiTheme: dataCaptureMuiTheme },
  events: { theme: eventsTheme, muiTheme: eventsMuiTheme },
  litigation: { theme: litigationTheme, muiTheme: litigationMuiTheme },
  mobile: { theme: mobileTheme, muiTheme: mobileMuiTheme },
  mra: { theme: mraTheme, muiTheme: mraMuiTheme },
  prodigyVirtualHelp: {
    theme: prodigyVirtualHelpTheme,
    muiTheme: prodigyVirtualHelpMuiTheme,
  },
  queue: { theme: queueTheme, muiTheme: queueMuiTheme },
  sketch: { theme: sketchTheme, muiTheme: sketchMuiTheme },
};

const getThemeNameByRoute = (route) => {
  if (route.indexOf('/appraisal-admin') === 0) {
    return 'appraisalAdmin';
  }

  if (route.indexOf('/bi/bradsql') === 0) {
    return 'bradsql';
  }

  if (route.indexOf('/bi') === 0) {
    return 'bi';
  }

  if (route.indexOf('/appraisal-process-manager') === 0) {
    return 'appraisalProcessManager';
  }

  if (route.indexOf('/appraisal') === 0) {
    return 'appraisal';
  }

  if (route.indexOf('/ci') === 0) {
    return 'ci';
  }

  if (route.indexOf('/dataCapture') === 0) {
    return 'dataCapture';
  }

  if (route.indexOf('/audits') === 0) {
    return 'audits';
  }

  if (route.indexOf('/events') === 0) {
    return 'events';
  }

  if (route.indexOf('/litigation') === 0) {
    return 'litigation';
  }

  if (route.indexOf('/assessment') === 0) {
    return 'assessment';
  }

  if (route.indexOf('/sketch') === 0) {
    return 'sketch';
  }

  if (route.indexOf('/mra') === 0) {
    return 'mra';
  }

  if (route.indexOf('/analysis') === 0) {
    return 'analysis';
  }

  if (route.indexOf('/appeals') === 0) {
    return 'appeals';
  }

  if (route.indexOf('/queue') === 0) {
    return 'queue';
  }

  if (route.indexOf('/mobile') === 0) {
    return 'mobile';
  }

  if (route.indexOf('/prodigyVirtualHelp') === 0) {
    return 'prodigyVirtualHelp';
  }

  if (route.indexOf('/conferencing') === 0) {
    return 'conferencing';
  }

  return 'base';
};

export const getMaterialTheme = R.compose(
  R.prop('muiTheme'),
  R.prop(R.__, themeMap),
  getThemeNameByRoute,
);

export const getTheme = R.compose(
  R.prop('theme'),
  R.prop(R.__, themeMap),
  getThemeNameByRoute,
);

export const getThemes = () => [
  analysisTheme,
  appealsTheme,
  appraisalTheme,
  assessmentTheme,
  auditsTheme,
  baseTheme,
  biTheme,
  bradsqlTheme,
  ciTheme,
  conferencingTheme,
  dataCaptureTheme,
  eventsTheme,
  litigationTheme,
  mobileTheme,
  prodigyVirtualHelpTheme,
  sketchTheme,
];
